/**
 * Se una azienda puo entrare, e cosa dirle quando non puo.
 *
 * Sta fra le cose condivise perche la stessa risposta serve al server, che chiude la porta,
 * e alla schermata, che la deve spiegare con garbo. **I dati non si toccano mai**: una prova
 * scaduta e una porta chiusa, non una cancellazione.
 */
export type CompanyLicenseStatus = "trial" | "customer" | "suspended";

export type CompanyAccess = {
  status: CompanyLicenseStatus;
  trialEndsAt: string | null;
  /** Giorni che mancano alla fine della prova; negativo se e gia passata, nullo se non scade. */
  daysLeft: number | null;
  blocked: boolean;
  reason: string | null;
};

const GIORNO = 24 * 60 * 60 * 1000;

export function companyAccess(
  input: { licenseStatus: CompanyLicenseStatus; trialEndsAt: Date | string | null },
  now: Date = new Date(),
): CompanyAccess {
  const fine = input.trialEndsAt ? new Date(input.trialEndsAt) : null;
  const daysLeft = fine ? Math.ceil((fine.getTime() - now.getTime()) / GIORNO) : null;
  const base = { status: input.licenseStatus, trialEndsAt: fine ? fine.toISOString() : null, daysLeft };

  if (input.licenseStatus === "suspended") {
    return { ...base, blocked: true, reason: "L'accesso a questa azienda e sospeso." };
  }
  if (input.licenseStatus === "trial" && fine && fine.getTime() <= now.getTime()) {
    return { ...base, blocked: true, reason: "Il periodo di prova e terminato." };
  }
  return { ...base, blocked: false, reason: null };
}

/** Il testo della schermata gentile: dice cosa succede ai dati e cosa fare adesso. */
export const ACCESS_BLOCKED_HELP =
  "I dati inseriti restano tutti al loro posto e tornano disponibili appena l'accesso viene riattivato. Per riprendere, contatta Cristian Bedin.";
